<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.interfaces.pageStripe.title') }}
    </portal>
    <template v-if="config !== null">
      <card :title="$t('admin.interfaces.pageStripe.card.general')" cols="12 6@desktop">

        <hm-card-inner :full-size="true">
          <hm-col v-if="isEmpty(config.publishableKey)" cols="12">
            <span class="info-text info-text--full-size col-12 info-text--no-margin" v-html="$t('admin.interfaces.pageStripe.hintConnectStripe')"></span>
          </hm-col>
        </hm-card-inner>
        <hm-card-inner>
          <hm-input-toggle :label="$t('admin.interfaces.pageStripe.enabled')"
                           :enabled-title="$t('enabled')"
                           :disabled-title="$t('disabled')"
                           :help="$t('admin.interfaces.pageStripe.enabled_help')"
                           :disabled="isEmpty(config.publishableKey)"
                           v-model="config.enabled"
                           cols="12 6@hd start-1"
                           name="enabled" />
          <hm-input :value="config.stripeUserId" disabled label="Stripe-User-ID" cols="12 6@hd start-1">
            <template slot="icon-inline-right" slot-scope="slot">
              <input-icon-button v-if="!isEmpty(config.stripeUserId) && hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                                 :border="true"
                                 :disabled="false"
                                 icon="link"
                                 @click="openStripe" />
            </template>
          </hm-input>
          <hm-input :value="config.publishableKey" disabled label="Stripe-Publishable-Key" cols="12 6@hd start-1" />
        </hm-card-inner>
      </card>
      <card :title="$t('admin.interfaces.pageStripe.card.stripeTerminal')" cols="12 6@desktop" v-if="hasLicense('StripeTerminal')">
        <hm-card-inner :full-size="true">
          <hm-table columns="2">
            <div class="hm-table__th">{{ $t('admin.interfaces.pageStripe.terminal.ID') }}</div>
            <div class="hm-table__th">{{ $t('admin.interfaces.pageStripe.terminal.label') }}</div>
            <template v-for="terminal in config.terminals">
              <div class="hm-table__td">{{ terminal.first }}</div>
              <div class="hm-table__td">{{ terminal.second }}</div>
            </template>
          </hm-table>
        </hm-card-inner>
        <hm-card-inner>
          <hm-button class="btn--no-margin btn--orange"
                     cols="12"
                     icon-left="refresh"
                     @click="terminal()">{{ $t('admin.interfaces.pageStripe.actions.terminal') }}</hm-button>
        </hm-card-inner>
      </card>
      <!-- payment methods -->
      <card :title="$t('admin.interfaces.pageStripe.card.paymentMethods')" cols="12 6@desktop">
        <hm-card-inner :full-size="true">
          <hm-table columns="1">
            <template v-for="paymentMethod in config.paymentMethods">
              <div class="hm-table__td">{{ $t(`PaymentServiceProviderPaymentMethod.${paymentMethod}`) }}</div>
            </template>
          </hm-table>
        </hm-card-inner>
        <hm-card-inner>
          <hm-button class="btn--no-margin btn--orange"
                     cols="12"
                     icon-left="refresh"
                     @click="paymentMethods()">{{ $t('admin.interfaces.pageStripe.actions.paymentMethods') }}</hm-button>
        </hm-card-inner>
      </card>
    </template>
    <hm-floating-buttons>
      <hm-floating-button :throttle="3500"
                          :label="$t('admin.interfaces.pageStripe.actions.connect')"
                          icon="fill-connect"
                          color="orange"
                          @click="connect()" />
      <hm-floating-button :throttle="3500"
                          :label="$t('admin.interfaces.pageStripe.actions.refresh')"
                          icon="refresh"
                          color="green"
                          @click="loadData()" />
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import Card from '../../../lib/layout/Card';
import HmInputCheckbox from '../../../lib/inputs/HmInputCheckbox';
import HmInputMoney from '../../../lib/inputs/HmInputMoney';
import HmCardInner from '../../../lib/layout/HmCardInner';
import HmTextarea from '../../../lib/inputs/HmTextarea';
import HmTable from '../../../lib/table/HmTable';
import { isNil } from 'lodash';

export default {
  name: 'PageStripe',
  components: { HmTable, HmTextarea, HmCardInner, HmInputMoney, HmInputCheckbox, Card },
  mixins: [HotelmeisterMixin, SaveWatchMixin],

  autosave: [
    {
      name: 'config',
      variable: 'config',
      event: 'hotelSettings.update',
      fn: function (cbSaveComplete) {
        this.axios.put(this.serviceUrls.interfaces.stripe.get(this, this.interfaceId), this.config)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      config: null,
      interfaceId: this.$route.params.interfaceId,
    };
  },

  computed: {
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.stripe.get(this, null))
        .then((response) => {
          this.config = response.data.data;
        });
    },
    connect() {
      this.axios.post(this.serviceUrls.interfaces.stripe.connect(this, null))
        .then((response) => {
          window.open(response.data.data.authorizationUrl, '_blank');
        });
    },
    terminal() {
      this.axios.post(this.serviceUrls.interfaces.stripe.terminal(this, null))
        .then((response) => {
          this.config = response.data.data;
          this.showSuccessMessage();
          this.$serviceBus.$emit('hotelSettings.update.immediate');
        });
    },
    paymentMethods() {
      this.axios.post(this.serviceUrls.interfaces.stripe.paymentMethods(this, null))
        .then((response) => {
          this.config = response.data.data;
          this.showSuccessMessage();
          this.$serviceBus.$emit('hotelSettings.update.immediate');
        });
    },
    openStripe() {
      window.open(`https://dashboard.stripe.com/connect/accounts/${this.config.stripeUserId}/activity`, '_blank');
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageStripe.vue